/**
 * Unified Content Page - Entry point for all content types
 * 
 * Routes:
 * - /movie/:slug -> content.contentType.kind === 'movie'
 * - /series/:slug -> content.contentType.kind === 'series'
 * - /program/:slug -> content.contentType.kind === 'program'
 */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import RootLayout from "../../app/layout";
import PageLayout from "../layout/PageLayout";
import UnifiedDetailPage from "./UnifiedDetailPage";
import AccessDeniedScreen from "../common/accessDenied";
import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";
import {
    getAgeRangePublicRoute,
    isContentItemAllowedForAgeRange,
} from "../../utils/ageRange.util";
import { startLoading, stopLoading } from "../../redux/Slices/loading.slice";

const ContentPage = () => {
    const { slug } = useParams();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const ageRange = getAgeRangePublicRoute();
    const dispatch = useDispatch();

    const getContent = async (slug) => {
        try {
            const response = await httpService.get(getCMSApiRoute("content"), {
                params: {
                    pageIndex: 10,
                    pageNumber: 1,
                    slug,
                },
            });

            if (response.status !== 200) {
                return response.status;
            }

            const { data } = response.data;
            return data.results.find((x) => x.slug === slug);
        } catch (error) {
            return error.response?.status || 500;
        }
    };

    useEffect(() => {
        // Start loading - disables sidebar navigation
        dispatch(startLoading("در حال بارگذاری..."));

        getContent(slug).then((data) => {
            setData(data);
            setLoading(false);
            // Stop loading - re-enables sidebar navigation
            dispatch(stopLoading());
        });
    }, [slug, dispatch]);

    // Check access restrictions
    if (
        !loading &&
        (!data || data === 400 || !ageRange || !isContentItemAllowedForAgeRange(data, ageRange, true))
    ) {
        return <AccessDeniedScreen />;
    }

    return (
        <RootLayout>
            <PageLayout loading={loading} skeletonType="detail">
                {!loading && data && <UnifiedDetailPage content={data} />}
            </PageLayout>
        </RootLayout>
    );
};

export default ContentPage;
